import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexComponent } from './pages/index/index.component';
import { ReportComponent } from './pages/report/report.component';
import { LandingComponent } from './pages/landing/landing.component';

const routes: Routes = [
  {
    path: '',
    // component: IndexComponent,
    component: LandingComponent,
    pathMatch: 'full'
  },
  { 
    path: 'report', 
    component: ReportComponent,
    pathMatch: 'full'
  },
  // {
  //   path: '',
  //   redirectTo: '/report',
  //   pathMatch: 'full'
  // },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
